<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t('permissionsPage.manageUserPermissions') }}</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <card>
                        <div class="m-3 flex-right">
                            <el-popover
                                placement="left"
                                :title="$t('usersPage.filterUsers')"
                                class="filter-container"
                                width="350"
                                trigger="click">
                                <base-button slot="reference" type="primary" outline class="filter-btn">
                                    <i class="m-0 ai ai-filter"></i>
                                    <i class="m-0 ai ai-angle-down"></i>
                                </base-button>
                                <el-form :model="filter" label-width="100px">
                                    <el-form-item :label="$t('general.name')">
                                        <el-input v-model="filter.name"></el-input>
                                    </el-form-item>

                                    <el-form-item :label="$t('general.email')">
                                        <el-input v-model="filter.email"></el-input>
                                    </el-form-item>

                                    <!--
                                    <el-form-item label="Application">
                                        <el-select v-model="filter.app" placeholder=" ">
                                            <el-option label="-- All --" :value="null"></el-option>
                                            <el-option
                                                v-for="app in applications"
                                                :key="app.id"
                                                :label="app.name"
                                                :value="app.id"></el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="Hotel">
                                        <el-select v-model="filter.hotel" placeholder=" ">
                                            <el-option label="-- All --" :value="null"></el-option>
                                            <el-option
                                                v-for="hotel in hotels"
                                                :key="hotel.id"
                                                :label="hotel.name"
                                                :value="hotel.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    -->
                                </el-form>
                            </el-popover>


                            <base-button
                                type="primary"
                                @click="exportPermissions"><i class="ai ai-download"></i> {{ $t('general.export') }}
                            </base-button>

                            <base-button
                                v-if="hotels.length > 1"
                                type="primary"
                                outline
                                @click="changeView">
                                <template v-if="matrixViewIsActive">
                                    <i class="ai ai-list"></i>
                                    {{ $t('permissionsPage.listView') }}
                                </template>
                                <template v-else="matrixViewIsActive">
                                    <i class="ai ai-grid"></i>
                                    {{ $t('permissionsPage.gridView') }}
                                </template>
                            </base-button>
                        </div>

                        <el-tabs
                            v-model="selectedAppId"
                            @tab-click="appChanged">
                            <el-tab-pane
                                v-for="app in applications"
                                :key="app.id"
                                :label="app.name"
                                :name="app.id.toString()">
                                <el-table class="table-responsive table-flush"
                                          border
                                          header-row-class-name="thead-light"
                                          :data="filteredData"
                                          :empty-text="isLoadingUsers
                                    ? $t('general.loading') + '...'
                                    : 'No Data'"
                                          lazy>

                                    <el-table-column
                                        :label="$t('general.name')"
                                        prop="name"
                                        :min-width="matrixViewIsActive ? '175px' : null"
                                        sortable/>

                                    <el-table-column
                                        v-if="!matrixViewIsActive"
                                        :label="$t('general.email')"
                                        prop="email" sortable>
                                        <template v-slot="{row: user}">
                                            {{ user.email }}
                                            <span
                                                v-if="!user.email_verified_at"
                                                class="text-danger">(not verified yet)</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        v-if="!matrixViewIsActive"
                                        :label="$t('general.actions')"
                                        width="225px">
                                        <template v-slot="{row: user}" v-if="hotels.length === 1">
                                            <el-select
                                                v-model="permissions[`u${user.id}h${hotels[0].id}a${selectedAppId}`]"
                                                size="mini"
                                                @change="saveMultiplePermissions(user.id, hotels[0].id, selectedAppId, $event)">
                                                <el-option
                                                    :label="$t('permissionsPage.noAccess')"
                                                    value="no_access"></el-option>
                                                <el-option
                                                    v-for="(perm, idx) in availablePermissions"
                                                    :key="idx"
                                                    :label="perm.label"
                                                    :value="perm.value"></el-option>
                                            </el-select>
                                        </template>
                                        <template v-slot="{row: user}" v-else-if="hotels.length > 1">
                                            <base-button
                                                type="primary"
                                                size="sm"
                                                @click="openPermissionSelector(user)">
                                                {{ $t('permissionsPage.selectPermissions') }}
                                            </base-button>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        v-if="matrixViewIsActive"
                                        v-for="hotel in hotels"
                                        :key="hotel.id"
                                        :label="hotel.name"
                                        min-width="175px">
                                        <template v-slot="{row: user}">
                                            <el-select
                                                v-model="permissions[`u${user.id}h${hotel.id}a${app.id}`]"
                                                size="mini"
                                                @change="saveMultiplePermissions(user.id, hotel.id, app.id, $event)">
                                                <el-option
                                                    :label="$t('permissionsPage.noAccess')"
                                                    value="no_access"></el-option>
                                                <el-option
                                                    v-for="(perm, idx) in availablePermissions"
                                                    :key="idx"
                                                    :label="perm.label"
                                                    :value="perm.value"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                </el-table>

                                <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    class="permission-pagination"
                                    :total="itemsCount"
                                    :page-size="itemsPerPage"
                                    @current-change="currentPage = $event">
                                </el-pagination>
                            </el-tab-pane>
                        </el-tabs>
                    </card>
                </div>
            </div>
        </div>

        <el-dialog
            v-if="hotels.length > 1 && selectedUser && !matrixViewIsActive"
            :title="$t('permissionsPage.setPermissionFor', {name: selectedUser.name || selectedUser.email})"
            :visible.sync="showPermissionSelectorModal"
            top="10vh"
            width="550px"
            custom-class="permission-editor-modal"
            @close="selectedUser = null">
            <el-table
                class="table-responsive table-flush"
                header-row-class-name="thead-light"
                :data="hotels">
                <el-table-column :label="$t('general.hotel')" prop="name" sortable></el-table-column>

                <el-table-column :label="$t('general.permission')" width="225px">
                    <template v-slot="{row: hotel}">
                        <el-select
                            v-model="permissions[`u${selectedUser.id}h${hotel.id}a${selectedAppId}`]"
                            size="mini"
                            @change="permissionChanged">
                            <el-option :label="$t('permissionsPage.noAccess')" value="no_access"></el-option>
                            <el-option
                                v-for="(perm, idx) in availablePermissions"
                                :key="idx"
                                :label="perm.label"
                                :value="perm.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table>
            <template slot="footer">
                <base-button
                    type="secondary"
                    @click="showPermissionSelectorModal = false">{{ $t('general.cancel') }}
                </base-button>
                <base-button
                    type="primary"
                    @click="saveMultiplePermissions()">{{ $t('general.saveChanges') }}
                </base-button>
            </template>
        </el-dialog>

    </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import {BaseProgress} from '@/components';
    import {
        Dialog,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Form,
        FormItem,
        Option,
        Pagination,
        Select,
        Table,
        TableColumn,
        TabPane,
        Tabs,
    } from 'element-ui'

    export default {
        name: 'user-list',
        components: {
            BaseProgress,
            [Dialog.name]: Dialog,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Select.name]: Select,
            [Option.name]: Option,
            [Pagination.name]: Pagination,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
        },
        computed: {
            ...mapGetters({
                matrixViewIsActive: 'matrixViewIsActive'
            }),
            filteredData: {
                get() {
                    let filteredUsers = JSON.parse(JSON.stringify(this.users));

                    // Filter by name
                    if (this.filter.name) {
                        filteredUsers = filteredUsers.filter(user => user.name.toLowerCase().includes(this.filter.name.toLowerCase()));
                    }

                    // Filter by email
                    if (this.filter.email) {
                        filteredUsers = filteredUsers.filter(user => user.email.toLowerCase().includes(this.filter.email.toLowerCase()));
                    }
                    // this.pageCount = Math.ceil(filteredUsers.length / this.itemsPerPage) || 1;

                    this.itemsCount = Object.values(this.filter).some(val => !!val) ? filteredUsers.length : this.users.length;

                    /* Pagination START */
                    const from = (this.currentPage - 1) * this.itemsPerPage;
                    const to = from + this.itemsPerPage;
                    filteredUsers = filteredUsers.slice(from, to);
                    /* Pagination END */

                    //for (const user of filteredUsers) {
                    //    user.relatedHotels = user.hotels.filter(hotel => {
                    //        const perm = user.permissions.find(p => p.hotel_id === hotel.id && p.permission !== 'no_access');
                    //        return !!perm;
                    //    })
                    //        .map(hotel => hotel.name)
                    //        .join(', ')

                    //    user.relatedApps = user.applications.filter(app => {
                    //        const perm = user.permissions.find(p => p.hotel_id === app.id && p.permission !== 'no_access');
                    //        return !!perm;
                    //    })
                    //        .map(app => app.name)
                    //        .join(', ')
                    //}

                    return filteredUsers;
                }
            },
        },
        data() {
            return {
                selectedAppId: null,
                availablePermissions: [],
                users: [],
                hotels: [],
                applications: [],
                permissions: {},
                showPermissionSelectorModal: false,
                selectedUser: null,
                currentPage: 1,
                itemsPerPage: 10,
                itemsCount: 0,
                isLoadingUsers: true,
                filter: {
                    hotels: null,
                    applications: null
                },
            }
        },
        methods: {
            changeView() {
                this.$store.commit('setMatrixViewState', !this.matrixViewIsActive);
            },
            appChanged(tab) {
                const selectedApp = this.applications.find(app => app.id === parseInt(tab.name));
                this.availablePermissions = selectedApp.available_permissions.map(perm => {
                    return {
                        label: this.$t('permissionsPage.' + perm),
                        value: perm,
                    }
                });
            },
            permissionChanged(val) {
                this.permissions = {...this.permissions};
            },
            openPermissionSelector(user) {
                this.selectedUser = {...user};
                this.showPermissionSelectorModal = true;
            },
            saveMultiplePermissions(userId, hotelId, applicationId, permission) {
                this.permissions = {...this.permissions};

                let data = {
                    userId: userId || this.selectedUser.id,
                    applicationId: applicationId || this.selectedAppId,
                    permissions: {},
                };

                if (hotelId) {
                    data.permissions[hotelId] = permission;
                } else {
                    for (const hotel of this.hotels) {
                        data.permissions[hotel.id] = this.permissions[`u${this.selectedUser.id}h${hotel.id}a${this.selectedAppId}`];
                    }
                }

                this.$axios.put('api/users/' + data.userId + '/permissions', data)
                    .then(res => {
                        this.$notify({
                            title: this.$t('general.saved'),
                        });
                    })
                    .catch(err => {
                        this.$notify({
                            title: this.$t('general.somethingWentWrong'),
                            type: 'danger',
                        });
                    });
            },
            exportPermissions() {
                this.$axios({
                    url: '/api/export-permissions',
                    method: 'GET',
                    responseType: 'blob', // important
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'permissions.xlsx');
                    const elem = document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(elem);
                });
            },
        },
        async created() {
            this.users = (await this.$axios.get('/api/users')).data.data;
            //this.hotels = (await this.$axios.get('/api/profile')).data.data.hotels;
            this.hotels = (await this.$axios.get('/api/hotels')).data.data;
            this.applications = (await this.$axios.get('/api/applications')).data.data;

            this.selectedApp = this.applications[0];
            this.selectedAppId = this.selectedApp ? this.selectedApp.id.toString() : null;
            this.availablePermissions = this.selectedApp ? this.selectedApp.available_permissions.map(perm => {
                return {
                    label: this.$t('permissionsPage.' + perm),
                    value: perm,
                }
            }) : [];

            for (const user of this.users) {
                for (const hotel of this.hotels) {
                    for (const app of this.applications) {
                        //this.permissions[`u${user.id}h${hotel.id}a${app.id}`] = {
                        //    user_id: user.id,
                        //    hotel_id: hotel.id,
                        //    application_id: app.id,
                        //    permission: 'no_access'
                        //}

                        this.permissions[`u${user.id}h${hotel.id}a${app.id}`] = 'no_access'
                    }
                }
            }

            for (const user of this.users) {
                for (const perm of user.permissions) {
                    //this.permissions[`u${user.id}h${perm.hotel_id}a${perm.application_id}`] = {...perm};
                    this.permissions[`u${user.id}h${perm.hotel_id}a${perm.application_id}`] = perm.permission;
                }
            }

            this.isLoadingUsers = false;
        }
    };
</script>
<style lang="scss">
    .filter-container {
        display: inline-flex;
        margin-right: .5rem;
    }

    .permission-editor-modal {
        .el-dialog__body {
            padding: 0;
        }
    }

    .permission-pagination {
        display: table;
        margin-left: auto;
        margin-right: auto;
        margin-top: 1rem;
    }

    .flex-right {
        display: flex;
        justify-content: flex-end;
    }
</style>
